import { useState } from "react"
import { toast } from "react-toastify"
import styled from "styled-components"

import { useLazyGenerateMasterPassQuery } from "store/api/adminApi"

import { ButtonNew } from "components/form/ButtonNew"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;

  div {
    margin-top: 20px;
    display: flex;
    gap: 10px;

    input {
      width: 100%;
      padding: 10px;
      border-radius: 5px;
    }
  }
`

const MasterPassText = styled.p`
  margin-top: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;

  h1 {
    font-size: 100px;
    font-weight: 600;
    color: #fff;
    text-align: center;
    width: 100%;
  }
`

export const MasterPass = () => {
  const [hash, setHash] = useState("")
  const [generatedMasterPass, setGeneratedMasterPass] = useState("")
  const [generateMasterPass] = useLazyGenerateMasterPassQuery()

  const handleGenerate = async () => {
    const res = await generateMasterPass({ data: hash })

    if (res.data?.data) {
      setGeneratedMasterPass(res.data.data)
    } else {
      toast.error("Failed to generate master password, try again")
    }
  }

  return (
    <Container>
      <h2>Hello, What is your code</h2>
      <div>
        <input
          type="text"
          maxLength={6}
          placeholder="e.g., 123456"
          value={hash}
          onChange={e => setHash(e.target.value)}
        />
        <ButtonNew color="blueBordered" onClick={handleGenerate}>
          Generate
        </ButtonNew>
      </div>
      {generatedMasterPass && (
        <MasterPassText>
          Your master password is: <h1>{generatedMasterPass}</h1>
        </MasterPassText>
      )}
    </Container>
  )
}
